module.exports = {
    ...require('./colorIcon'),
    ...require('./copyButton'),
    ...require('./qrCodeButton'),
    ...require('./common'),
    ...require('./loading'),
    ...require('./boxes'),
    ...require('./tabs'),
    ...require('./transactionsTable'),
    ...require('./connectMetamask'),
    ...require('./contractTab')
}
